<template>
  <div class="layout">
    <div id="band">ddd</div>
    <h2>台灣樂團大揭秘</h2>
    <section class="section">
      <div class="img_layout" v-for="(item, index) in news" :key="index">
        <a class="h31" :id="item.cls + index" :href="item.ID" target="blank">{{ item.Image }}</a>
        <img :src="'https://www.ftvnews.com.tw/topics/taiwanband/' + item.Image + '.jpg'" v-bind:class="'img' + index"
          alt="" srcset="">
        <!-- <img src="../assets/百合花.jpg" alt=""> -->
        <a :href="item.ID" target="blank">
          <div class="mask" v-bind:class="'img' + index">
            <p class="mask_text">{{ item.Title }}</p>
          </div>
        </a>
      </div>
    </section>
    <button id="spotlight">
      <a href="https://www.ftvnews.com.tw/tag/台灣樂團專題" target="_blank">點我看更多樂團專訪</a></button>
  </div>
</template>
<script>

export default {

  name: 'App',
  data() {
    return {
      news: [
        { Title: '前浪不會死在沙灘上，而是與後浪繼續向前行！', Image: '幻眼', ID: 'https://www.ftvnews.com.tw/news/detail/2023330W0342' },
        { Title: '發揚在地前往國際！專訪董事長樂團　用音樂傳達自由價值', Image: '董事長', ID: 'https://www.ftvnews.com.tw/news/detail/2023330W0317' },
        { Title: '爛也是種美學！B級精神逆襲搖滾界', Image: '八十八顆芭樂籽', cls: 'limit', ID: 'https://www.ftvnews.com.tw/news/detail/2023328W0108' },
        { Title: '文學系卻來做音樂！？音樂文學創作新境界', Image: '裝咖人', ID: 'https://www.ftvnews.com.tw/news/detail/2023328W0096' },
        { Title: '專訪血肉果汁機！用多變音樂風格乘載台灣文化的血與肉', Image: '血肉果汁機', cls: 'limit', ID: 'https://www.ftvnews.com.tw/news/detail/2023330W0320' },
        { Title: '這場表演禁止拍手？台味樂團分析表演生態', Image: '拍謝少年', ID: 'https://www.ftvnews.com.tw/news/detail/2023327W0188' },
        { Title: '源於舊事物的可能性！探索百合花創作新境', Image: '百合花', ID: 'https://www.ftvnews.com.tw/news/detail/2023327W0270' },
        { Title: '風格再進化！滅火器暢談新專輯《家和萬事興》', Image: '滅火器', ID: 'https://www.ftvnews.com.tw/news/detail/2023530W0246' },
        // 其他新聞數據...
      ]
    }
  },
}
</script>

<style scoped>
#band {
  position: relative;
  color: transparent;
  top: -5rem;
}


.section {
  margin: 2rem 0;
  border-radius: 31px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

@media screen and (max-width:768px) {
  .section {
    grid-template-columns: 1fr 1fr;
  }
}

section {
  border: 2px solid rgb(0, 0, 0);
}

section img {
  /* border: 2px solid black; */
  width: 100%;
  height: 100%;
  object-fit: cover;

}

.img_layout {
  position: relative;
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}



.mask {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(173, 149, 92, 0.2) 0%, rgb(251, 185, 28) 88.6%);
  opacity: .1;
}


@media screen and (max-width:768px) {
  .mask {
    background: linear-gradient(180deg, rgba(173, 149, 92, 0.2) 0%, rgb(0, 0, 0, .3) 33.6%);
    opacity: .8;
  }
}


.mask p {
  position: absolute;
  bottom: 15px;
  width: fit-content;
  margin: auto 1rem;
  text-align: center;
  color: #030303;
  opacity: 0;
  font-size: 1.2rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
}



.img_layout a:hover .mask {
  opacity: 1;
  transition: .3s all;
}


.img_layout a:hover .mask p {
  opacity: 1;
}




@media screen and (max-width:768px) {


  section img {
    /* border: 2px solid black; */
    width: 100%;
  }

  .img_layout {
    position: relative;
    width: 100%;
    height: 200px
  }

  .mask p {
    position: absolute;
    bottom: 15px;
    width: fit-content;
    margin: auto 1rem;
    text-align: center;
    color: transparent;
    opacity: 0;
    font-size: 2rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: justify;
  }




}


.img0 {
  border-radius: 30px 0px 0px 0px;
}

.img1 {}

.img2 {}

.img3 {
  border-radius: 0px 30px 0px 0px;
}

.img4 {
  border-radius: 0px 0px 0px 30px;
}

.img5 {}

.img6 {}

.img7 {
  border-radius: 0px 0px 30px 0px;
}



@media screen and (max-width:768px) {

  .img0 {
    border-radius: 30px 0px 0px 0px;

  }

  .img1 {
    border-radius: 0px 30px 0px 0px;
  }

  .img2 {
    border-radius: 0px;
  }

  .img3 {
    border-radius: 0px;
  }

  .img4 {
    border-radius: 0px;
  }

  .img5 {}

  .img6 {
    border-radius: 0px 0px 0px 30px;
  }

  .img7 {
    border-radius: 0px 0px 30px 0px;
  }

}

.h31 {
  position: absolute;
  font-weight: 900;
  font-size: 2.3rem;
  padding: 1rem;
  letter-spacing: 0.3em;
  color: #FFFFFF;
  justify-content: center;
  letter-spacing: .5rem;
  align-items: center;
  text-align: center;
  font-family: "Noto Serif TC", "Noto Serif";
  text-align: justify;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  text-shadow: 1px 4px 5px rgba(0, 0, 0, 0.4);
}

@media screen and (max-width:900px) {
  .h31 {

    font-size: 2rem;
  }

}


@media screen and (max-width:768px) {
  .h31 {
    text-align: center;
    font-size: 2.5rem;
  }

  #limit2 {
    width: 180px
  }
}

@media screen and (max-width:500px) {
  .h31 {
    text-align: center;
    font-size: 1.6rem;
    z-index: 9;
  }

  #limit2 {
    width: 140px;

  }

  #limit4 {
    width: 110px;


  }

  .img_layout {
    position: relative;
    width: 100%;
    height: 120px;
  }
}
</style>
